import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import {gridMargin} from "./general";

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import {withStyles} from "@material-ui/core";

const styles = () => {
	return {
		disabledInput: {
			color : '#333',
		},
		disabledLabel : {
			color : 'rgba(0, 0, 0, 0.6) !important',
		}
	}
};

class FormTextNoEdit extends PureComponent {
	render () {
		const {
			label, value, onChange, path,
			error, gridProps, helpText, required,
			classes,
		} = this.props;

		const hasError = !!error;
		const _onChange = event => onChange(event.target.value, path);

		const helperText = (hasError)
			? error
			: (helpText) ? helpText : null;

		const content = (
			<FormControl
				disabled={true}
				fullWidth={true}
				error={hasError}
			>
				<InputLabel
					htmlFor="component-disabled"
					classes={{ disabled : classes.disabledLabel }}
				>
					{label}
				</InputLabel>
				<Input id="component-disabled"
				       value={value}
				       onChange={_onChange}
				       required={required}
				       autoComplete={path}
				       disabled={true}
				       disableUnderline={true}
				       classes={{ disabled : classes.disabledInput }}

				/>
				{helperText && <FormHelperText>{helperText}</FormHelperText>}
			</FormControl>
		);

		if (gridProps) {
			_.defaults(gridProps, { xs : 12 });
			return (<Grid item {...gridProps} style={gridMargin}>{content}</Grid>);
		} else {
			return content;
		}
	}
}

FormTextNoEdit.propTypes = {
	label : PropTypes.string.isRequired,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,

	error : PropTypes.string,
	helpText : PropTypes.string,
	disabled : PropTypes.bool,
	required : PropTypes.bool,

	inputType : PropTypes.string,
	gridProps : PropTypes.object,
};

export default withStyles(styles)(FormTextNoEdit);
